export default __webpack_public_path__ + "static/media/template_3_new.2cb7296c.png";